import { render, staticRenderFns } from "./SpeakerModal.vue?vue&type=template&id=2d1c10fa&"
import script from "./SpeakerModal.vue?vue&type=script&lang=js&"
export * from "./SpeakerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports